import type { RouteRecordRaw } from 'vue-router'
import SourceOfFundsPage from './SourceOfFundsPage.vue'

export const sourceOfFundsRoutes: RouteRecordRaw[] = [
  {
    path: '/compliance/source-LOf-LFunds',
    name: 'compliance.sourceOfFunds',
    component: SourceOfFundsPage,
    meta: { layout: 'admin', requiresAuth: true },
  },
]
